import { Button } from '@predoc/cow';
import { cn } from '@/lib/utils';
import { MedicationDataType, MedicationDataCounts } from './types';
import { MEDICATION_DATA_TYPES } from './constants';

interface MedicationDataSidebarProps {
  counts?: MedicationDataCounts;
  selectedType: MedicationDataType;
  onSelectType: (type: MedicationDataType) => void;
  isLoading?: boolean;
}

export const MedicationDataSidebar = ({
  counts,
  selectedType,
  onSelectType,
  isLoading = false,
}: MedicationDataSidebarProps) => {
  return (
    <div className="w-56 shrink-0 rounded-lg bg-gray-100 p-3">
      <nav className="space-y-0.5" aria-label="Medication data categories">
        {MEDICATION_DATA_TYPES.map((dataType) => {
          const isSelected = selectedType === dataType.key;
          const count = counts?.[dataType.countKey] ?? 0;

          return (
            <Button
              key={dataType.key}
              variant="ghost"
              onClick={() => onSelectType(dataType.key)}
              aria-label={`${dataType.label} - ${count} records`}
              aria-current={isSelected ? 'true' : undefined}
              className={cn(
                'flex h-auto w-full items-center justify-between rounded-md px-3 py-1.5 text-left text-sm transition-colors',
                isSelected
                  ? 'text-foreground bg-white font-medium hover:bg-white'
                  : 'text-muted-foreground hover:text-foreground hover:bg-white',
              )}
            >
              <span>{dataType.label}</span>
              {isLoading ? (
                <span className="h-4 w-6 animate-pulse rounded bg-gray-200" />
              ) : (
                <span
                  className={cn(
                    'rounded-full bg-gray-200 px-2 py-0.5 text-xs',
                    isSelected ? 'text-foreground' : 'text-muted-foreground',
                  )}
                >
                  {count}
                </span>
              )}
            </Button>
          );
        })}
      </nav>
    </div>
  );
};
